module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc",
      "xmlns:epub": "http://www.idpf.org/2007/ops"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "href": "#/About#toc_marker-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Title_Page#toc_marker-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/Copyright#toc_marker-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright Information")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Contents#toc_marker-4"
    }
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Faries#toc_marker-5"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Faries1#toc_marker-6"
    }
  }, [_vm._v("One")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Faries2#toc_marker-7"
    }
  }, [_vm._v("Two")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Faries3#toc_marker-8"
    }
  }, [_vm._v("Three")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Faries4#toc_marker-9"
    }
  }, [_vm._v("Four")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Faries5#toc_marker-10"
    }
  }, [_vm._v("Five")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Faries6#toc_marker-11"
    }
  }, [_vm._v("Six")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Faries7#toc_marker-12"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Faries8#toc_marker-13"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/Faries9#toc_marker-14"
    }
  }, [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "x1toc",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_vm._v("contents"), _c('a', {
    attrs: {
      "id": "x-contents-"
    }
  })]), _c('a', {
    attrs: {
      "id": "x-contents-"
    }
  }), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "id": "x-contents-"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Faries#Anchor"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Faries1#Anchor-2"
    }
  }, [_vm._v("One")]), _vm._v(": Getting Started with Faeries")]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Faries2#Anchor-3"
    }
  }, [_vm._v("Two")]), _vm._v(": Communicating with Elementals to Understand and Improve Your Life")]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Faries3#Anchor-4"
    }
  }, [_vm._v("Three")]), _vm._v(": Sylphs–Elementals of Air")]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Faries4#Anchor-5"
    }
  }, [_vm._v("Four")]), _vm._v(": Salamanders–Elementals of Fire")]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Faries5#Anchor-6"
    }
  }, [_vm._v("Five")]), _vm._v(": Undines–Elementals of Water")]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Faries6#Anchor-7"
    }
  }, [_vm._v("Six")]), _vm._v(": Gnomes–Elementals of Earth")]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Faries7#Anchor-8"
    }
  }, [_vm._v("Conclusion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Faries8#Anchor-9"
    }
  }, [_vm._v("Glossary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-1"
  }, [_c('a', {
    attrs: {
      "href": "#/Faries9#Anchor-10"
    }
  }, [_vm._v("Bibliography")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b439491","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contents.vue
// module id = 66
// module chunks = 0